/* [BD feat] Product Gallery Swiper (With Empty Metafield Fallback) */
(function() {
  'use strict';

  if (typeof Swiper === 'undefined') return;

  function initProductGallery() {
    const galleryContainer = document.querySelector('.bd-product-gallery');
    if (!galleryContainer) return;

    const mainSliderEl = galleryContainer.querySelector('[data-main-slider]');
    const thumbsSliderEl = document.querySelector('[data-thumbs-slider]');
    if (!mainSliderEl) return;

    const usesMetafields = mainSliderEl.getAttribute('data-uses-metafields') === 'true';
    let originalMainSlides = [];
    let originalThumbSlides = [];
    
    // --- Fetch Product First Image for Fallbacks ---
    let productFirstImage = '';
    const dataScript = document.querySelector('[data-variant-data]');
    if (dataScript) {
      try {
        const vData = JSON.parse(dataScript.textContent);
        productFirstImage = vData.productFirstImage;
      } catch(e) {}
    }

    // Filter Logic for Metafield Images
    if (usesMetafields) {
      const mainWrapper = mainSliderEl.querySelector('.swiper-wrapper');
      const thumbWrapper = thumbsSliderEl ? thumbsSliderEl.querySelector('.swiper-wrapper') : null;

      originalMainSlides = Array.from(mainWrapper.children);
      if (thumbWrapper) originalThumbSlides = Array.from(thumbWrapper.children);

      // Get initial selected variant
      const currentVariantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
      const initialVariantId = currentVariantInput ? currentVariantInput.value : originalMainSlides[0]?.dataset.variantId;

      filterDOMForVariant(initialVariantId, mainWrapper, thumbWrapper);
    }

    // Initialize Swiper
    let thumbsSlider = null;
    if (thumbsSliderEl) {
      thumbsSlider = new Swiper(thumbsSliderEl, {
        spaceBetween: 8,
        slidesPerView: 2.2,
        watchSlidesProgress: true,
        freeMode: true,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          sensitivity: 1
        },
        breakpoints: { 
          750: { 
            slidesPerView: 3.5, 
            spaceBetween: 12 
          } 
        }
      });
    }

    const mainSlider = new Swiper(mainSliderEl, {
      spaceBetween: 10,
      thumbs: thumbsSlider ? { swiper: thumbsSlider } : undefined,
      on: { slideChange: pauseAllVideos }
    });

    // Handle Variant Changes natively via Pub/Sub
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
        const variant = event.data?.variant;
        if (!variant) return;

        if (usesMetafields) {
          const filteredMain = originalMainSlides.filter(s => s.dataset.variantId == variant.id);
          
          mainSlider.removeAllSlides();
          if (thumbsSlider) thumbsSlider.removeAllSlides();

          if (filteredMain.length > 0) {
            // Re-inject the correct Metafield images dynamically
            mainSlider.appendSlide(filteredMain.map(el => el.cloneNode(true)));

            if (thumbsSlider) {
              const filteredThumbs = originalThumbSlides.filter(s => s.dataset.variantId == variant.id);
              thumbsSlider.appendSlide(filteredThumbs.map(el => el.cloneNode(true)));
            }
          } else {
            // [FALLBACK] If no metafield images exist for this variant, use featured or first image
            const fallbackSrc = variant.featured_image || productFirstImage;
            if (fallbackSrc) {
               mainSlider.appendSlide(`<div class="swiper-slide"><img src="${fallbackSrc}" class="bd-product-gallery__image" loading="lazy" width="1200" height="1200"></div>`);
               if (thumbsSlider) {
                 thumbsSlider.appendSlide(`<div class="swiper-slide"><img src="${fallbackSrc}" class="bd-product-gallery__thumb-image" loading="lazy" width="200" height="200"></div>`);
               }
            }
          }
          
          mainSlider.update();
          if (thumbsSlider) thumbsSlider.update();
          mainSlider.slideTo(0);

        } else if (variant.featured_media) {
          // Fallback to Standard Shopify Images
          const slideIndex = Array.from(mainSlider.slides).findIndex(slide => 
            slide.getAttribute('data-media-id') == variant.featured_media.id
          );
          if (slideIndex !== -1) mainSlider.slideTo(slideIndex);
        }
      });
    }

    // Helpers
    function filterDOMForVariant(variantId, mainWrapper, thumbWrapper) {
      mainWrapper.innerHTML = '';
      if (thumbWrapper) thumbWrapper.innerHTML = '';

      const filteredMain = originalMainSlides.filter(s => s.dataset.variantId == variantId);
      
      if (filteredMain.length > 0) {
        filteredMain.forEach(slide => mainWrapper.appendChild(slide.cloneNode(true)));

        if (thumbWrapper) {
          const filteredThumbs = originalThumbSlides.filter(s => s.dataset.variantId == variantId);
          filteredThumbs.forEach(slide => thumbWrapper.appendChild(slide.cloneNode(true)));
        }
      } else {
        // [INITIAL LOAD FALLBACK] If page loads on a variant with no metafields
        let fallbackSrc = productFirstImage;
        const dataScript = document.querySelector('[data-variant-data]');
        if (dataScript) {
           try {
               const vData = JSON.parse(dataScript.textContent);
               const initialVar = vData.variants.find(v => v.id == variantId);
               if (initialVar && initialVar.featured_image) fallbackSrc = initialVar.featured_image;
           } catch(e) {}
        }

        if (fallbackSrc) {
           mainWrapper.innerHTML = `<div class="swiper-slide"><img src="${fallbackSrc}" class="bd-product-gallery__image" loading="lazy" width="1200" height="1200"></div>`;
           if (thumbWrapper) {
              thumbWrapper.innerHTML = `<div class="swiper-slide"><img src="${fallbackSrc}" class="bd-product-gallery__thumb-image" loading="lazy" width="200" height="200"></div>`;
           }
        }
      }
    }

    function pauseAllVideos() {
      mainSliderEl.querySelectorAll('video').forEach(video => { if (!video.paused) video.pause(); });
      mainSliderEl.querySelectorAll('iframe').forEach(iframe => { iframe.src = iframe.src; });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProductGallery);
  else initProductGallery();

})();